import { VODProviderType } from 'hamrah-player';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import React, { useMemo } from 'react';
import { Button } from '@/DesignSystem/Component';
import HeaderBarWelcome from '@/Module/Auth/Component/HeaderBarWelcome/HeaderBarWelcome';
import { setSectionWelcome } from '@/Module/Auth/Store/Slice/AuthSlice';
import { useDeviceType } from '@/Module/Core/Hook';
import { DeviceType } from '@/Module/Core/Model/Enum';
import { useAppDispatch, useAppSelector } from '@/Module/Store/Hook';
const Player = dynamic(() => import('hamrah-player').then(value => value.Player), {
  ssr: false
});
const VideoDescriptionLogin: FC = () => {
  const deviceType = useDeviceType();
  const activeCategoryId = useAppSelector(state => state.auth.parentId);
  const dispatch = useAppDispatch();
  const router = useRouter();
  const isSubscription = router?.query?.redirectUrl?.includes('subscription') || false;
  const setNextSection = () => {
    dispatch(setSectionWelcome(4));
    localStorage.setItem('step', '4');
    if (isSubscription) {
      // eslint-disable-next-line unused-imports/no-unused-vars
      const {
        redirectUrl,
        ...restQuery
      } = router.query;
      router.replace({
        pathname: router.pathname,
        query: restQuery
      }, undefined, {
        shallow: true
      });
    }
  };
  const VideoDetail = useMemo(() => {
    switch (activeCategoryId) {
      case 1:
        return {
          mobileVideoUrl: '296981',
          videoUrl: '296981'
        };
      case 2:
        return {
          mobileVideoUrl: '296984',
          videoUrl: '296984'
        };
      case 3:
        return {
          mobileVideoUrl: '296986',
          videoUrl: '296986'
        };
      default:
        return {
          mobileVideoUrl: '296986',
          videoUrl: '296986'
        };
    }
  }, [activeCategoryId]);
  const {
    mainUrl
  } = useMemo(() => {
    return {
      mainUrl: (deviceType === DeviceType.MOBILE ? VideoDetail.mobileVideoUrl : VideoDetail.videoUrl) ?? VideoDetail.videoUrl
    };
  }, [deviceType, VideoDetail]);
  return <div data-sentry-component="VideoDescriptionLogin" data-sentry-source-file="VideoDescriptionLogin.tsx">
      <HeaderBarWelcome step={2} data-sentry-element="HeaderBarWelcome" data-sentry-source-file="VideoDescriptionLogin.tsx" />
      <div className={`mb-2 mt-4 px-1 font-extrabold text-blueFive ${deviceType === DeviceType.MOBILE ? 'text-md' : 'text-xl'}`}>
        یادگیری با آی‌نو آسون‌تره
      </div>
      <div className="mb-4 text-sm text-blueFive  ">آی‌نو یادگیری رو آسون کرده! می‌گی نه؟ این ویدیو رو ببین! </div>
      <div className="relative aspect-[314/480] md:aspect-[360/200]" id="play-video">
        <Player classname="absolute" playUrl={mainUrl} vodCustomUrl={{
        [VODProviderType.ABR_HAMRAHI]: '/vod/abrehamrahi/{token}'
      }} vodType={VODProviderType.ABR_HAMRAHI} data-sentry-element="Player" data-sentry-source-file="VideoDescriptionLogin.tsx" />
      </div>
      <Button id="next-video" bold className="relative mt-4 w-full" variant="shadow" color="primary" radius="circle" size="large" onClick={setNextSection} data-sentry-element="Button" data-sentry-source-file="VideoDescriptionLogin.tsx">
        مرحله بعدی
      </Button>
    </div>;
};
export default VideoDescriptionLogin;